import * as yup from 'yup';

export const login = yup.object({
  email: yup.string().required('email.presence').email('email.invalid'),
  password: yup.string().required('password.presence')
});

export const signUp = yup.object({
  email: yup.string().required('email.presence').email('email.invalid'),
  password: yup.string().required('password.presence'),
  passwordConfirmation: yup
    .string()
    .required('passwordConfirmation.presence')
    .oneOf([yup.ref('password')], 'passwordConfirmation.equality')
});
